import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as reportParametersActions from '../actions/report-parameters.actions';

export interface ReportParametersState {
    reportParameters: any;
    loading: boolean;
    loaded: boolean;
}

const initialState = {
    reportParameters: null,
    loading: false,
    loaded: false
};

export const reportParametersReducer = (state = initialState, action) => {
    switch(action.type){
        case reportParametersActions.GET_CR_REPORT_PARAMETER_LIST:
            return {
                ...state,
                loading: true,
                loaded: state.loaded
            };
        case reportParametersActions.GET_CR_REPORT_PARAMETER_LIST_SUCCESS:
            return {
                ...state,
                reportParameters: action.payload,
                loading: false,
                loaded: true,
            };
        case reportParametersActions.GET_CR_REPORT_PARAMETER_LIST_FAIL:
            return {
                ...state,
                error: action.payload,
                loading: false,
                loaded: false
            };
        default:
            return state;
    }
};

export const getReportParametersState = createFeatureSelector<ReportParametersState>('reportParametersReducer');

export const getReportParametersList = (state: ReportParametersState) => state.reportParameters;
export const getReportParametersListLoaded = (state: ReportParametersState) => state.loaded;
